import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ClickOutsideDirective, EnvironmentsService } from '@out-web/core';
import { ImageComponent } from '../../../../atoms/image/image.component';
import { Auth0User, LocalAuthService } from '@out-web/core';
import { Observable } from 'rxjs';
@Component({
  selector: 'out-header',
  imports: [
    CommonModule,
    ImageComponent,
    RouterLink,
    RouterLinkActive,
    ClickOutsideDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Input() logoSrc = '';
  @Input() sideLogoSrc = '';
  @Input() menuItems!: {
    url: string;
    label: string;
    external?: boolean;
    icon?: boolean;
    auth?: boolean;
    click?: () => void;
    class?: string;
    isRegister?: boolean;
    initialQueryParams?: { [key: string]: string } | undefined;
  }[];
  @Input() isAuthenticated!: boolean;
  @Input() navLinks!: {
    url: string;
    label: string;
    external?: boolean;
    icon?: boolean;
    auth?: boolean;
    click?: () => void;
    class?: string;
    isRegister?: boolean;
    isLogout?: boolean;
    head?: boolean;
    initialQueryParams?: { [key: string]: string } | undefined;
  }[];
  showDropdown = false;
  isSidebarVisible = false;
  currentLink: string | null = null;
  user$: Observable<Auth0User>;

  constructor(
    public auth: AuthService,
    @Inject(DOCUMENT) public document: Document,
    private router: Router,
    public environmentService: EnvironmentsService,
    private localAuthService: LocalAuthService
  ) {
    this.user$ = this.localAuthService.user$;
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentLink = event.urlAfterRedirects;
      }
    });

    this.currentLink = this.router.url;
  }

  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  login() {
    this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({
      logoutParams: {
        returnTo: `${window.location.origin}/logout`,
      },
    });
  }

  setCurrentLink(url: string) {
    this.currentLink = url;
  }
}
